import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, StockplaceItem, LogisticService } from '../../../services/logistic.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { RememberService } from '../../../core/services/remember.service';

@Component({
    selector: 'tt-stock-historic',
    templateUrl: './stock-historic.component.html',
    styleUrls: ['./stock-historic.component.css']
})
export class StockHistoricComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService, private logistic: LogisticService, private remember: RememberService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3455))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_stockhistoric_grid')
                .setLoadDataFunction({
                    method: 3456,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public retrieveChanges() {
        this.loadGrid();
    }

    public async onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                await this.loadStockPlaces();
                if (!this.selectListStockPlaces.find((s) => s.stockplace_id === this.setting?.stockplace_id)) {
                    this.setting.stockplace_id = this.selectListStockPlaces?.[0]?.stockplace_id ?? '0';
                }
                this.remember.remember('w_stockhistoric.stockplace_id', this.setting.stockplace_id);

                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadStockPlaces();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    historic_stock_date: string;
    show_setting: string;
}
